import React from "react";
import Icon from "../icons/Icon";
import Pill from "../ui/Pill";
import { RULE_GROUP_META } from "../../domain/inconsistencyRules";
import { ruleStatus } from "../../domain/inconsistencies";

// A regra é um botão, não um link: abre um painel na mesma tela em vez de
// navegar. Regra zerada perde o botão junto com a afordância — não há
// ocorrência para abrir.
function RuleRow({ rule, count, onOpen }) {
  const meta = RULE_GROUP_META[rule.group];
  const status = ruleStatus(count);
  const zeroed = count === 0;

  return (
    <tr className={zeroed ? "is-zero" : undefined} title={rule.description}>
      <td className="rule-name">
        {zeroed ? (
          <span data-testid="rule-name">{rule.label}</span>
        ) : (
          <button
            className="row-link row-link-block"
            type="button"
            aria-haspopup="dialog"
            onClick={() => onOpen(rule.id)}
            data-testid="rule-name"
          >
            {rule.label}
          </button>
        )}
      </td>
      <td className="col-group">
        <Pill variant={meta.pill}>{meta.label}</Pill>
      </td>
      <td className="occ col-occ" data-testid="rule-count">
        {count}
      </td>
      <td className="col-status" data-testid="rule-status">
        <Pill variant={status.pill}>{status.label}</Pill>
      </td>
      <td className="col-go">
        <div className="go">{!zeroed && <Icon name="chevron-right" />}</div>
      </td>
    </tr>
  );
}

export default RuleRow;
